import { Injectable } from '@angular/core';
import { AnnouncementStore } from './announcement.store';
import { ApiService } from '../../shared/services/core/api.service';
import { Observable, of } from 'rxjs';

import { AnnouncementModel } from './models/announcement.model';
import { tap, mapTo } from 'rxjs/operators';
import { AnnouncementQuery } from './announcement.query';

@Injectable({ providedIn: 'root' })
export class AnnouncementService {
  constructor(
    private announcementStore: AnnouncementStore,
    private api: ApiService,
    private announcementQuery: AnnouncementQuery
  ) {}


  /** Fetch all announcements and put them in the store. */
  fetchAnnouncements(): Observable<null> {
    this.announcementStore.setLoading(true);

    const request$: Observable<null> = this.api.get<AnnouncementModel>('announcements').pipe(
      tap(announcements => {
        this.announcementStore.set(announcements);
      }),
      mapTo(null)
    );

    return this.announcementQuery.getHasCache() ? of(null) : request$;
  }
}
